<template>
  <div
    class="eduSecuritySituation"
  >
    <div class="top">
      <div class="left">
        <div class="left-list">
          <span class="icon-1"></span>
          <span class="txt-1">重大风险</span>
        </div>
        <div class="left-list">
          <span class="icon-2"></span>
          <span class="txt-2">较大风险</span>
        </div>
        <div class="left-list">
          <span class="icon-3"></span>
          <span class="txt-3">一般风险</span>
        </div>
        <div class="left-list">
          <span class="icon-4"></span>
          <span class="txt-4">低风险</span>
        </div>
      </div>
      <div class="right">
        <theNowTime></theNowTime>
        <div class="drop-out" @click="loginOut"></div>
      </div>
    </div>
    <div class="content">
      <div class="left">
        <dv-border-box-11 title="发现隐患分类占比" class="hidden-danger">
          <unsafe-type-echarts
            v-if="resData.dangerDynamicTypes"
            :echartsData="resData.dangerDynamicTypes"
          ></unsafe-type-echarts>
        </dv-border-box-11>
        <div class="hidden-danger-now">
          <div class="now-name">
            <div class="danger-title">
              <span :class="danger_tab==1?'active':''" @click="danger_tab=1">隐患实时动态</span>
              <span :class="danger_tab==1?'':'active'" @click="danger_tab=2">消防实时动态</span>
            </div>
            <img
              src="@/assets/img/eduBigData/hidden-danger-now-light.png"
              alt=""
            />
          </div>
          <hidden-danger-now
            v-if="danger_tab == 1"
            :hiddenTroubleList="resData.hiddenTroubleList"
          ></hidden-danger-now>
              
          <div v-if="danger_tab == 2" style="height:158px;overflow: hidden;width:100%;font-size:16px;color:#eaeaea;line-height:120px;">
            暂无报警信息
            <!-- <protect-now
              :protectList="resData.realTimeGuardingRecord"
            ></protect-now> -->
          </div>

        </div>
        <div class="prowl">
          <div class="prowl-around">
            <div class="subtitle">
              <div class="prowl-list">
                <div class="prowl-num">
                  {{ resData.spectionareasNum }}<span>个</span>
                </div>
                <div class="prowl-label">巡查点总数</div>
              </div>
              <div class="prowl-list">
                <div class="prowl-num">
                  {{ resData.spectionareasHeNum }}<span>个</span>
                </div>
                <div class="prowl-label">巡查上报隐患数量</div>
              </div>
            </div>
            <stacked-line-chart
              v-if="resData.patrolStatistics"
              class="prowl-around-line"
              :echartsData="resData.patrolStatistics"
            >
            </stacked-line-chart>
          </div>
        </div>
      </div>
      <div class="center" style="margin-top:-20px">
        <hidden-danger-num
          :num="resData.troubleNum"
          msg="区域内隐患点"
        ></hidden-danger-num>

        <div class="statistic">
          <div class="list">
            <div class="list-num">
              {{ resData.schoolInfo.schoolNum }}
              <!-- <count-to-component
                :num="resData.schoolInfo.schoolNum"
              ></count-to-component> -->
              <span>所</span>
            </div>
            <div class="list-name">学校总数</div>
          </div>
          <div class="list">
            <div class="list-num">
              <!-- <count-to-component
                :num="numberInfo.teacherNum"
              ></count-to-component> -->
             
              {{resData.schoolInfo.userNum>10000?(resData.schoolInfo.userNum / 10000).toFixed(2):resData.schoolInfo.userNum }}
              <span v-if="resData.schoolInfo.userNum > 10000">万</span>
              <span>人</span>
            </div>
            <div class="list-name">教师总数</div>
          </div>
          <div class="list">
            <div class="list-num">
              <!-- <count-to-component
                :num="numberInfo.studentNum"
              ></count-to-component> -->
               {{resData.schoolInfo.stuNum>10000?(resData.schoolInfo.stuNum / 10000).toFixed(2):resData.schoolInfo.stuNum }}
              <!-- {{ (resData.schoolInfo.stuNum / 10000).toFixed(2) }} -->
              <span v-if="resData.schoolInfo.stuNum > 10000">万</span>
              <span>人</span>
            </div>
            <div class="list-name">学生总数</div>
          </div>
        </div>
        <div class="map">
          <map-content
            :cityArr="cityArr"
            :cityCode="cityCode"
            @refreshData="refreshData"
            :isbaifen="false"
            :tooltip="tooltip"
            :pieces="pieces"
          ></map-content>
        </div>
      </div>
      <div class="right">
        <div class="rate">
          <div class="rate-title">
            <span>安全工作分项得分</span>
          </div>

          <rate-list-chart
            class="classification"
            v-if="resData.areaScore.scoreClass"
            :echartsData="resData.areaScore.scoreClass"
          >
          </rate-list-chart>

          <div class="rate-head">
            <div>排名</div>
            <div>地区</div>
            <div>得分</div>
          </div>
          <div class="rate-content">
            <div
              v-for="(item, index) in sortedArray"
              :key="index"
              @click="selRateCity(item)"
            >
              <div class="rate-list">
                <div class="rate-num">
                  {{ index + 1 }}
                  <img
                    v-if="index == 0"
                    src="@/assets/img/rateIcon/rate-1.png"
                    alt=""
                  />
                  <img
                    v-if="index == 1"
                    src="@/assets/img/rateIcon/rate-2.png"
                    alt=""
                  />
                  <img
                    v-if="index == 2"
                    src="@/assets/img/rateIcon/rate-3.png"
                    alt=""
                  />
                </div>
                <div class="rate-name">{{ item.name }}</div>
                <div class="rate-score">{{ item.score }}分</div>
              </div>
            </div>
            <rate-list-pie
              :rateCount="rateCount"
              :echartsData="rateCity"
            ></rate-list-pie>
          </div>
        </div>
        <div class="protect-info">
          <div class="protect-head">
            <div
              class="protect-sel"
              :class="{ active: protectStatus == 1 }"
              @click="protectStatus = 1"
            >
              安全信息
            </div>
            <div
              class="protect-sel"
              :class="{ active: protectStatus == 0 }"
              @click="protectStatus = 0"
            >
              护学实时动态
            </div>
          </div>
          <div class="protect-list" v-if="protectStatus == 0">
            <protect-now
              :protectList="resData.realTimeGuardingRecord"
            ></protect-now>
          </div>
          <div class="jurisdictional-area" v-show="protectStatus == 1">
            <div class="area" @click="check(0)">
              <div class="area-left">
                <div class="list-num">
                  {{ resData.drillPlanSchoolTotal }}<span>所</span>
                </div>
                <div class="list-label">演练学校</div>
              </div>
              <div class="area-right">
                <div class="list-num">
                  {{ resData.drillPlanTotal }}<span>次</span>
                </div>
                <div class="list-label">演习次数</div>
              </div>
            </div>
            <div class="area" @click="check(1)">
              <div class="area-left">
                <div class="list-num">
                  {{ resData.monitorSchoolTotal }}<span>所</span>
                </div>
                <div class="list-label">接入视频学校</div>
              </div>
              <div class="area-right">
                <div class="list-num">
                  {{ resData.monitorTotal }}<span>处</span>
                </div>
                <div class="list-label">接入视频总数</div>
              </div>
            </div>
            <div class="area" @click="check(2)">
              <div class="area-left">
                <div class="list-num">
                  {{ resData.voiceSchoolTotal }}<span>所</span>
                </div>
                <div class="list-label">接入广播学校</div>
              </div>
              <div class="area-right">
                <div class="list-num">
                  {{ resData.voiceTotal }}<span>条</span>
                </div>
                <div class="list-label">接入广播总数</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <edu-security-situation-area-dialog
      :selResize="selResize"
      :searchParams="searchParams"
    ></edu-security-situation-area-dialog>
  </div>
</template>

<script>
import theNowTime from "./components/theNowTime";
import hiddenDangerNow from "./components/hiddenDangerNow";
import hiddenDangerNum from "./components/hiddenDangerNum";
import unsafeTypeEcharts from "./components/unsafeTypeEcharts";
import stackedLineChart from "./components/stackedLineChart";
import rateListChart from "./components/rateListChart";
import rateListPie from "./components/rateListPie";
import eduSecuritySituationAreaDialog from "./components/eduSecuritySituationAreaDialog";
import mapContent from "./components/mapContent";
// import secret from '@/publicFunction/secret';
import CountToComponent from "@/components/CountToComponent";
import protectNow from "./components/protectNow";
export default {
  name: "",
  components: {
    theNowTime,
    hiddenDangerNow,
    hiddenDangerNum,
    unsafeTypeEcharts,
    stackedLineChart,
    rateListChart,
    rateListPie,
    eduSecuritySituationAreaDialog,
    mapContent,
    CountToComponent,
    protectNow
  },
  props: {},
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      resData: {
        hiddenTroubleList: [],
        troubleNum: 0,
        schoolInfo: {
          schoolNum: 0,
          userNum: 0,
          stuNum: 0
        },
        areaScore: {
          scoreRank: []
        }
      },
      areaScore: {
          scoreRank: []
      },
      rateCount: 0,
      rateCity: {
        scoreClass: []
      },
      // 查看下属区域信息传的信息
      selResize: 0,
      searchParams: {
        type: "",
        eduId: JSON.parse(sessionStorage.getItem("eduInfo")).eduId,
        regionCode: JSON.parse(sessionStorage.getItem("eduInfo")).regionCode,
        eduBuresuType: JSON.parse(sessionStorage.getItem("eduInfo"))
          .eduBuresuType
      },
      cityArr: [],
      cityCode: "",
      pieces: [
        { gt: 240, label: "重大风险", color: "#FF6464" },
        { gt: 160, lte: 240, label: "较大风险", color: "#FF995A" },
        { gt: 80, lte: 160, label: "一般风险", color: "#E9D74C" },
        { gt: -1, lte: 80, label: "低风险", color: "#6363FF" }
      ],
      tooltip: [
        // {title:'风险值',value:'value'},
        { title: "学校数", value: "schoolCot" },
        { title: "教师数", value: "userCot" },
        { title: "学生数", value: "stuCot" },
        { title: "隐患数", value: "troubleCot" }
      ],
      numberInfo: {
        teacherNum: 0,
        studentNum: 0
      },
      protectStatus: 1,
      protectList: [],
      danger_tab: 1,
    };
  },
  created() {
    // if (this.$route.query.code) {
    // 	let decrypt = secret.Decrypt(this.$route.query.code)
    // 	let codeArr = decrypt.split('&')
    // 	// console.log(codeArr[0], codeArr[1])
    // 	this.userLogin(codeArr[0], codeArr[1])
    // } else {
    let req = {
      eduId: this.eduInfo.eduId,
      regionCode: parseInt(this.eduInfo.regionCode),
      eduBuresuType: this.eduInfo.eduBuresuType
    };
    this.getEduSecuritySituation(req, true);
    // }
  },
  mounted() {},
  computed: {
    sortedArray() {
      return this.resData.areaScore.scoreRank.sort((b, a) => a.score - b.score);
    }
  },
  watch: {},
  methods: {
    // 登录
    async userLogin(loginId, userPwd) {
      var requestData = {
        loginId: loginId,
        userPwd: userPwd
      };
      let res = await this.$Http.userLogin(requestData, true);
      // console.log(res)
      if (res.code == 200) {
        var userInfo = {
          userId: res.data.userId,
          userName: res.data.userName,
          userPhone: res.data.userPhone,
          email: res.data.email,
          token: res.data.token,
          userIdNumber: res.data.userIdNumber,
          loginId: res.data.loginId,
          headPortrait: res.data.headPortrait,
          eduId: res.data.eduId,
          eduBuresuType: res.data.eduBuresuType,
          schoolId: res.data.schoolId
        };
        sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
        var newUserInfo = sessionStorage.getItem("userInfo");
        this.$store.commit("updateUserInfo", newUserInfo);

        sessionStorage.setItem("schoolId", res.data.schoolId);
        this.$store.commit(
          "updateSchoolId",
          sessionStorage.getItem("schoolId")
        );
        if (userInfo.eduId != 0) {
          this.getEduInfo();
        }
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    // 获取教育局信息
    async getEduInfo() {
      var requestData = {
        eduId: this.$store.getters.getUserInfo.eduId
      };
      let res = await this.$Http.getEduInfo(requestData);
      if (res.code == 200) {
        var eduInfo = res.data;
        sessionStorage.setItem("eduInfo", JSON.stringify(eduInfo));
        if (sessionStorage.getItem("eduInfo")) {
          this.$store.commit(
            "updateEduInfo",
            sessionStorage.getItem("eduInfo")
          );
          // console.log(sessionStorage.getItem("eduInfo"), "------------");
          let req = {
            eduId: eduInfo.eduId,
            regionCode: parseInt(eduInfo.regionCode),
            eduBuresuType: eduInfo.eduBuresuType
          };
          this.getEduSecuritySituation(req, true);
        }
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    selRateCity(rate) {
      this.rateCity = rate;
      this.rateCount++;
    },
    check(num) {
      this.searchParams.type = num;
      this.selResize++;
    },
    refreshData(obj) {
      this.searchParams = {
        type: "",
        eduId: obj.eduId,
        regionCode: parseInt(obj.regionCode),
        eduBuresuType: obj.eduBuresuType
      };

      let req = {
        eduId: obj.eduId,
        regionCode: parseInt(obj.regionCode),
        eduBuresuType: obj.eduBuresuType
      };
      this.getEduSecuritySituation(req);
    },
    async getEduSecuritySituation(req) {
      // this.loading = true;
      let res = await this.$Http.getEduSecuritySituation(req);
      // this.loading = false;
      this.cityCode = req.regionCode + "";
      // console.log(res);
      if (res.code == 200) {
        if (res.data) {
          this.resData = res.data;
          this.numberInfo.teacherNum =
            this.resData.schoolInfo.userNum > 10000
              ? Number((this.resData.schoolInfo.userNum / 10000).toFixed(2))
              : this.resData.schoolInfo.userNum;
          this.numberInfo.studentNum =
            this.resData.schoolInfo.stuNum > 10000
              ? Number((this.resData.schoolInfo.stuNum / 10000).toFixed(2))
              : this.resData.schoolInfo.stuNum;

          //   模拟数据
          //   this.resData.patrolStatistics = [{"persons":20568,"ym":"2020-06","patroled":24080,"noPatrol":1265},
          //   {"persons":35978,"ym":"2020-07","patroled":24070,"noPatrol":2684},
          //   {"persons":40000,"ym":"2020-08","patroled":34040,"noPatrol":3658},
          //   {"persons":50000,"ym":"2020-09","patroled":54100,"noPatrol":4521},
          //   {"persons":70000,"ym":"2020-10","patroled":34807,"noPatrol":1236},
          //   {"persons":60000,"ym":"2020-11","patroled":54687,"noPatrol":2546},
          //   {"persons":90000,"ym":"2020-12","patroled":45008,"noPatrol":1000},
          //   {"persons":80000,"ym":"2021-01","patroled":30681,"noPatrol":1000},
          //   {"persons":110000,"ym":"2021-02","patroled":44940,"noPatrol":1358},
          //   {"persons":100000,"ym":"2021-03","patroled":34105,"noPatrol":1235},
          //   {"persons":120000,"ym":"2021-04","patroled":36730,"noPatrol":522},
          //   {"persons":130000,"ym":"2021-05","patroled":34200,"noPatrol":1627}]
          //   this.resData.hiddenTroubleList = [{"timer":"2021-05-12 14:35:18","details":"【永城市第五小学】张建国上传给曹宝芹一条隐患","id":847,"schoolName":"永城市第五小学","status":0},
          //                                     {"timer":"2021-05-12 14:35:07","details":"【济源市沁园中学】李朝霞上传给郭建立一条隐患","id":846,"schoolName":"济源市沁园中学","status":0},
          //                                     {"timer":"2021-05-12 14:31:02","details":"【三门峡市外国语中学】靳可心上传给崔玉民一条隐患","id":845,"schoolName":"三门峡市外国语中学","status":0}]
          //   this.resData.areaScore.scoreRank = [
          //       {"score":"245.5","name":"济源市","scoreClass":[{"name":"组织领导","num":13.0},{"name":"基础建设","num":15.5},{"name":"安全管理","num":176.0},{"name":"制度建设","num":10.0},{"name":"安全教育","num":17.5},{"name":"专项治理","num":5.0},{"name":"主动防御","num":8.5}]},
          //       {"score":"185.4","name":"焦作市","scoreClass":[{"name":"组织领导","num":4.5},{"name":"基础建设","num":3.5},{"name":"安全管理","num":73.0},{"name":"制度建设","num":0.0},{"name":"安全教育","num":64.5},{"name":"专项治理","num":0.0},{"name":"主动防御","num":21.0}]},
          //       {"score":"174.3","name":"郑州市","scoreClass":[{"name":"组织领导","num":4.5},{"name":"基础建设","num":3.5},{"name":"安全管理","num":73.0},{"name":"制度建设","num":0.0},{"name":"安全教育","num":64.5},{"name":"专项治理","num":0.0},{"name":"主动防御","num":21.0}]},
          //       {"score":"166.5","name":"信阳市","scoreClass":[{"name":"组织领导","num":5.2},{"name":"基础建设","num":4.3},{"name":"安全管理","num":11.6},{"name":"制度建设","num":3.3},{"name":"安全教育","num":2.0},{"name":"专项治理","num":1.7},{"name":"主动防御","num":8.7}]},
          //       {"score":"36.8","name":"南阳市","scoreClass":[{"name":"组织领导","num":5.2},{"name":"基础建设","num":4.3},{"name":"安全管理","num":11.6},{"name":"制度建设","num":3.3},{"name":"安全教育","num":2.0},{"name":"专项治理","num":1.7},{"name":"主动防御","num":8.7}]}]
          let data = res.data.areaMapInfos || [];
          this.cityArr = data.map((item) => {
            item.name = item.regionName;
            item.value = item.maxRiskType; //风险值
            return item;
          });
        }
      } else if (res.code == 101) {
      } else {
      }
    },
    loginOut() {
      this.$confirm("此操作将退出当前账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$Common.loginOut();
          this.$message({
            type: "success",
            message: "退出成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出"
          });
        });
    }
  },
  destroyed() {}
};
</script>
<style lang="scss">
.eduSecuritySituation{
  .el-loading-mask{
    top:-98px !important;
    height:110vh !important;
  }
}
</style>
<style lang="scss" scoped>
.top {
  margin-top: -10px;
  width: 100%;
  padding: 0 3.8%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    width: 34.85%;
    height: 30px;
    display: flex;
    .left-list {
      display: flex;
      width: 118px;
      align-items: center;
      .icon-1 {
        width: 20px;
        height: 20px;
        background: #ff0000;
        border-radius: 4px;
      }
      .txt-1 {
        margin-left: 8px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #c4cdff;
        line-height: 20px;
      }
      .icon-2 {
        width: 20px;
        height: 20px;
        background: #ff6100;
        border-radius: 4px;
      }
      .txt-2 {
        margin-left: 8px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #c4cdff;
        line-height: 20px;
      }
      .icon-3 {
        width: 20px;
        height: 20px;
        background: #ffff00;
        border-radius: 4px;
      }
      .txt-3 {
        margin-left: 8px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #c4cdff;
        line-height: 20px;
      }
      .icon-4 {
        width: 20px;
        height: 20px;
        background: #00b6ff;
        border-radius: 4px;
      }
      .txt-4 {
        margin-left: 8px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #c4cdff;
        line-height: 20px;
      }
    }
  }
  .right {
    width: 23.39%;
    display: flex;
    // justify-content: flex-end;
    // flex-direction: row;
    justify-content: space-between;
    .drop-out {
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      transition: transform 0.3s;
      cursor: pointer;
      height: 30px;
      width: 66px;
      background: url("~@/assets/img/eduBigData/login-out.png");
      background-size: 100% 100%;
      &:hover {
        transform: scale(1.1);
      }
    }
  }
}
.content {
  display: flex;
  padding: 0 3.8% 0 3.8%;
  justify-content: space-between;
  .left {
    width: 24.48%;
    .hidden-danger {
      margin-top: 10px;
      width: 100%;
      height: 250px;
    }
    .name {
      padding-top: 2px;
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #effaff;
      letter-spacing: 1px;
      background: linear-gradient(180deg, #ffffff 0%, #cdf2ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .info {
      // margin-top: 44px;
      height: 200px;
    }
    .hidden-danger-now {
      margin-top: 12px;
      width: 100%;
      height: 210px;
      background: url("~@/assets/img/eduBigData/hidden-danger-now-bg.png")
        center center no-repeat;
      background-size: 100% 100%;
      text-align: center;
      .now-name {
        padding-top: 8px;
        text-align: center;
        position: relative;
        div {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          // color: #effaff;
          letter-spacing: 1px;
          background: linear-gradient(180deg, #ffffff 0%, #cdf2ff 100%);
          -webkit-background-clip: text;
          // -webkit-text-fill-color: transparent;
        }
        img {
        }
      }
      .danger-title{
        display: flex;
        justify-content: space-around;
        span{
          cursor: pointer;
          color:#68c9e9;
        }
        .active{
          color:#fff;
        }
      }
    }
    .prowl {
      margin-top: 12px;
      display: flex;
      justify-content: center;
      .prowl-around {
        width: 100%;
        height: 290px;
        background: url("~@/assets/img/eduBigData/prowl-around-bg.png") center
          center no-repeat;
        background-size: 100% 100%;
      }
      .subtitle {
        margin-top: 22px;
        display: flex;
        justify-content: space-between;
      }
      .prowl-list {
        width: 136px;
        text-align: center;
        position: relative;
        top: -2px;
        &:first-child {
          padding-left: 25px;
        }
        &:last-child {
          padding-right: 10px;
        }
      }
      .prowl-label {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #c4f0ff;
      }
      .prowl-num {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #c4f0ff;
        line-height: 22px;
        background: linear-gradient(180deg, #eeeeee 0%, #fff45d 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        span {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #c4f0ff;
          line-height: 22px;
          background: linear-gradient(180deg, #eeeeee 0%, #fff45d 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      .prowl-around-line {
        // width: 800px;
        height: 250px;
        padding: 0 10px;
      }
    }
  }
  .center {
    width: 800px;
    text-align: center;
    .statistic {
      display: flex;
      justify-content: center;
      margin-top: 10px;
      .list {
        width: 112px;
        height: 65px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background: url("~@/assets/img/eduBigData/big-data-school-bg.png")
          center center no-repeat;
        background-size: 100% 100%;
        margin-right: 77px;
        &:last-child {
          margin-right: 0;
        }
      }
      .list-num {
        margin-top: -6px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #c4f0ff;
        line-height: 25px;
        background: linear-gradient(180deg, #eeeeee 0%, #5d71ff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        span {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #c4f0ff;
          line-height: 25px;
          background: linear-gradient(180deg, #eeeeee 0%, #5d71ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      .list-name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #c4f0ff;
        line-height: 20px;
      }
    }
    .map {
      width: 100%;
      height: 400px;
      margin-top: -40px;
    }
  }
  .right {
    width: 23.39%;
    margin-top: 10px;
    .rate {
      padding: 29px 28px 0 40px;
      width: 100%;
      height: 460px;
      background: url("~@/assets/img/eduBigData/big-data-rate-bg.png") center
        center no-repeat;
      background-size: 100% 100%;
      .rate-title {
        width: 176px;
        height: 33px;
        background: linear-gradient(
          89deg,
          rgba(63, 120, 188, 0) 0%,
          #3f78bc 42%,
          rgba(63, 120, 188, 0) 100%
        );
        span {
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #a6e4f9;
          line-height: 33px;
          background: linear-gradient(180deg, #ffffff 0%, #cdf2ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      .classification {
        width: 100%;
        height: 230px;
        overflow: scroll;
        scrollbar-width: none;
      }
      .rate-head {
        margin-bottom: 8px;
        display: flex;
        justify-content: space-between;
        padding: 0 24px;
        div {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #c4cdff;
          line-height: 25px;
        }
      }
      .rate-content {
        height: 130px;
        overflow: scroll;
        scrollbar-width: none;
      }
      .rate-list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 38px;
        background: rgba(17, 165, 215, 0.5);
        border-radius: 4px;
        margin-bottom: 8px;
        cursor: pointer;
        &:nth-child(2n) {
          background: rgba(17, 165, 215, 0.2);
        }
        .rate-num {
          flex: 0 0 25%;
          padding-left: 40px;
          text-align: left;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #c4cdff;
          line-height: 28px;
          letter-spacing: 1px;
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          img {
            width: 36px;
            height: 32px;
            position: absolute;
            top: 1px;
            left: 4px;
          }
        }
        .rate-name {
          flex: 0 0 50%;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #c4cdff;
          line-height: 22px;
          text-align: center;
        }
        .rate-score {
          flex: 0 0 25%;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #c4cdff;
          line-height: 22px;
          text-align: center;
        }
        &:nth-child(1) {
          .rate-score {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #c4cdff;
            line-height: 22px;
            background: linear-gradient(180deg, #edefff 0%, #fff04d 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        &:nth-child(2) {
          .rate-score {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #c4cdff;
            line-height: 22px;
            background: linear-gradient(180deg, #edefff 0%, #4d76ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        &:nth-child(3) {
          .rate-score {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #c4cdff;
            line-height: 22px;
            background: linear-gradient(180deg, #ffffff 0%, #8e6236 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }
    .protect-info {
      margin-top: 11px;
      .protect-head {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .protect-sel {
          color: #a6e4f9;
          font-size: 18px;
          cursor: pointer;
          &.active {
            color: #fffded;
          }
        }
      }
      .protect-list {
        width: 100%;
        height: 244px;
        background: url("~@/assets/img/eduBigData/hidden-danger-now-bg.png")
          center center no-repeat;
        background-size: 100% 100%;
      }
      .jurisdictional-area {
        margin-top: 10px;
        padding-top: 5px;
        width: 100%;
        height: 244px;
        background: url("~@/assets/img/eduBigData/jurisdictional-area-bg.png")
          center center no-repeat;
        background-size: 100% 100%;
        position: relative;
        .area {
          display: flex;
          justify-content: space-between;
          margin-bottom: 38px;
          padding: 0 20px;
          cursor: pointer;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .area-left {
          text-align: left;
        }
        .area-right {
          text-align: right;
        }
        .list-label {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #effaff;
          line-height: 22px;
        }
        .list-num {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #effaff;
          line-height: 28px;
          background: linear-gradient(180deg, #ffffe9 0%, #ffec96 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          span {
            font-size: 14px;
          }
        }
      }
    }
  }
}
.count-to-box {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #c4f0ff;
}
</style>
